import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types'; // @ts-expect-error untyped dependency

import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName'; // @ts-expect-error untyped dependency

import UnknownName from 'customer-data-reference-ui-components/name/UnknownName'; // @ts-expect-error untyped dependency

import { AUTOMATION_PLATFORM_WORKFLOWS } from 'reference-resolvers/constants/ReferenceObjectTypes';
import WorkflowDetailsFooter from 'automation-contextual-components/components/WorkflowDetailsFooter';
import { WorkflowDetailsTitle } from 'automation-contextual-components/components/WorkflowDetailsTitle';
import Trackables from 'automation-contextual-components/_internal/tracking/Trackables';
import { trackEvent } from 'automation-contextual-components/_internal/tracking/trackingUtils';
import { getWorkflowUrl } from 'automation-contextual-components/utils/urlUtils';
const WorkflowDetailPropTypes = {
  id: PropTypes.number.isRequired,
  isExternalLink: PropTypes.bool.isRequired,
  onLinkClick: PropTypes.func.isRequired
};

const WorkflowDetail = ({
  id,
  isExternalLink,
  onLinkClick
}) => /*#__PURE__*/_jsx(ReferenceName, {
  id: id,
  onError: () => /*#__PURE__*/_jsx(UnknownName, {
    referenceObjectType: AUTOMATION_PLATFORM_WORKFLOWS
  }),
  onResolved: ({
    reference
  }) => {
    const {
      isEnabled,
      updateMetadata,
      // TODO: Remove once updated resolver is merged
      createMetadata,
      // TODO: Remove once updated resolver is merged
      name,
      uuid,
      portalId,
      updatedAt,
      createdSourceApp,
      updatedUserId
    } = reference.referencedObject.toJS();
    const userId = createMetadata ? createMetadata.updatedBy ? createMetadata.updatedBy.userId : null : updatedUserId;
    const dateUpdated = updateMetadata ? updateMetadata.updatedAt : updatedAt;
    const sourceApp = createMetadata ? createMetadata.sourceApp : createdSourceApp;
    const workflowUrl = getWorkflowUrl({
      flowId: id,
      portalId,
      sourceApp,
      uuid
    });

    const onClick = () => {
      trackEvent(Trackables.NAVIGATE_TO_WORKFLOW, {
        sourceApp
      });
      onLinkClick({
        flowId: id
      });
    };

    return /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "m-bottom-2",
        "data-test-id": `workflow-details-${id}-root`,
        children: [/*#__PURE__*/_jsx(WorkflowDetailsTitle, {
          workflowName: name,
          workflowUrl: workflowUrl,
          isExternalLink: isExternalLink,
          onClick: onClick
        }), /*#__PURE__*/_jsx(WorkflowDetailsFooter, {
          isEnabled: isEnabled,
          userId: userId,
          dateUpdated: dateUpdated
        })]
      })
    });
  },
  referenceObjectType: AUTOMATION_PLATFORM_WORKFLOWS
});

WorkflowDetail.propTypes = WorkflowDetailPropTypes;
export default WorkflowDetail;